import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = {};

export default handleActions(
  {
    [Actions.LOAD_DONE]: (state, { payload: { langURLList } }) => ({
      ...state,
      ...langURLList,
    }),
  },
  initialState,
);
